export const EMBEDDED_CASHIER_CSS_ID = 'cashier_custom_css';

export interface EmbeddedCashierCss {
  css: string;
  url: string;
}

export const isAbsoluteHttpsUrl = (raw: string): boolean => {
  if (typeof raw !== 'string' || !/^https:\/\//i.test(raw)) return false;

  try {
    return new URL(raw).protocol === 'https:';
  } catch (e) {
    return false;
  }
};

export const readEmbeddedCashierCss = (doc: Document = document): EmbeddedCashierCss => {
  try {
    const element = doc.getElementById(EMBEDDED_CASHIER_CSS_ID);

    if (!element) return { css: '', url: '' };

    if (element.tagName === 'LINK') {
      const raw = element.getAttribute('href') ?? '';

      return { css: '', url: isAbsoluteHttpsUrl(raw) ? raw : '' };
    }

    if (element.tagName === 'STYLE') {
      return { css: element.textContent ?? '', url: '' };
    }

    return { css: '', url: '' };
  } catch (e) {
    return { css: '', url: '' };
  }
};
